// Bounce Function
// t: time, 0 to 1
export default function cubicEaseInOutBounce(t: number): number {
  if (t < 0.5) return 8 * t * t * t; // Ease-in
  return -2 * (t - 1) * (t - 1) * (t - 1) + 1; // Ease-out
}